import { useEffect } from 'react'

import { Drawer, Icon, Layout, Steps } from '@loadsmart/miranda-react'

import { RequestStatus } from 'core/domain/Request'

import { useGetOpenDockWarehouseFormFields } from '../hooks/usetGetOpenDockWarehouseFormFields'
import { useOpenDockDrawer } from './OpenDockDrawerContext'
import { RectangleSkeleton } from './RectangleSkeleton'
import { SendInfoForm } from './SendInfoForm'

export function SendInfo() {
  const {
    setStep,
    shipmentUUID,
    stopIndex,
    fields,
    facilityTimezone,
    warehouseDetails,
    carrierId,
    onConfirm,
    onClose,
  } = useOpenDockDrawer()

  const {
    fetchOpenDockWarehouseFormFields,
    warehouseFormFields,
    status: warehouseFormFieldsStatus,
  } = useGetOpenDockWarehouseFormFields()

  useEffect(() => {
    fetchOpenDockWarehouseFormFields(shipmentUUID, stopIndex, fields.staticFields.loadType!.id)
  }, [fetchOpenDockWarehouseFormFields, fields.staticFields.loadType, shipmentUUID, stopIndex])

  if (warehouseFormFieldsStatus === RequestStatus.Pending) {
    return (
      <>
        <Drawer.Body>
          <Layout.Stack gap="spacing-4" paddingB="spacing-2">
            <Steps activeStep="send-info" style={{ gap: '0' }}>
              <Steps.Step completed name="schedule">
                Schedule
              </Steps.Step>
              <Steps.Step name="send-info">Send Info</Steps.Step>
            </Steps>
            {warehouseFormFieldsStatus === RequestStatus.Pending && (
              <Layout.Stack>
                <RectangleSkeleton />
                <RectangleSkeleton />
              </Layout.Stack>
            )}
          </Layout.Stack>
        </Drawer.Body>
        <Drawer.Actions>
          <Drawer.ActionTertiary
            onClick={() => setStep('schedule')}
            leading={<Icon name="arrow-left" color="color-text-disabled" />}
            disabled
          >
            Back
          </Drawer.ActionTertiary>
          <Drawer.ActionPrimary disabled>Confirm appointment</Drawer.ActionPrimary>
        </Drawer.Actions>
      </>
    )
  }

  if (warehouseFormFields) {
    return (
      <SendInfoForm
        setStep={setStep}
        fields={fields}
        facilityTimezone={facilityTimezone!}
        warehouseDetails={warehouseDetails}
        warehouseFormFields={warehouseFormFields}
        shipmentUUID={shipmentUUID}
        openDockCarrierId={carrierId}
        stopIndex={stopIndex}
        onConfirm={onConfirm}
        onClose={onClose}
      />
    )
  }

  return null
}
